import Vue from 'vue';
import App from './App.vue';
import './plugins';
import './global.css';
import './spacing.css';
import 'font-awesome/css/font-awesome.css';
import { store } from './store';
import router from './router';
import JSEncrypt from 'jsencrypt';

Vue.config.productionTip = false;
// import VConsole from 'vconsole';

// const vConsole = new VConsole();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

Vue.prototype.$jsEncrypt = JSEncrypt;

declare module 'vue/types/vue' {
  interface Vue {
    $jsEncrypt: any;
  }
}
